import createGenericSlice from "../GenericSlice";
import { GenericState } from "../../Models/Common/Common";
import { PayloadAction } from "@reduxjs/toolkit";
import CommonServices from "../../Services/Common/CommonServices";
import { Account } from "../../Models/Account/Account";
import UnitServices from "./../../Services/Unit/UnitServices";

interface ICommonData {
  allCars: any[];
  geoNames: any[];
  allCities: any[];
  showNavigation: boolean;
  profileInfo: Account;
}

const defaultValues: ICommonData = {
  allCars: [],
  geoNames: [],
  allCities: [],
  showNavigation: true,
  profileInfo: <Account>{},
};
export const slice = createGenericSlice({
  name: "commonData",
  initialState: {
    status: "loading",
    data: defaultValues,
  } as GenericState<ICommonData>,
  reducers: {
    setAllCars: (state: any, action: PayloadAction<any>) => {
      state.status = "finished";
      const { newData, sliceState } = action.payload;
      state.data = {
        ...sliceState,
        allCars: newData,
      };
    },
    setCities: (state: any, action: PayloadAction<any>) => {
      state.status = "finished";
      const { newData, sliceState } = action.payload;
      state.data = {
        ...sliceState,
        allCities: newData,
      };
    },
    setGeoNames: (state: any, action: PayloadAction<any>) => {
      state.status = "finished";
      const { newData, sliceState } = action.payload;
      state.data = {
        ...sliceState,
        geoNames: newData,
      };
    },

    setProfileInfo: (state: any, action: PayloadAction<any>) => {
      state.status = "finished";
      const { newData, sliceState } = action.payload;
      state.data = {
        ...sliceState,
        profileInfo: newData,
      };
    },
    setShowNavigation: (state: any, action: PayloadAction<any>) => {
      state.status = "finished";
      const { newData, sliceState } = action.payload;
      state.data = {
        ...sliceState,
        showNavigation: newData,
      };
    },
  },
});

export const selectCommonData = (state: {
  commonData: { data: ICommonData };
}) => state?.commonData?.data;

export const {
  setAllCars,
  setGeoNames,
  setCities,
  setProfileInfo,
  setShowNavigation,
} = slice.actions;

export default slice.reducer;

export const GetAllCars = () => (dispatch: any, getState: any) => {
  CommonServices.GetAllCars((e) => {
    e.brands?.forEach((item: any) => {
      Object.assign(item, { text: item.description });
    });
    dispatch(
      setAllCars({
        newData: e?.brands,
        sliceState: getState()?.commonData?.data,
      })
    );
  });

  UnitServices.GetAvailableCities({}, (e) => {
    e.geoNames?.forEach((item: any) => {
      Object.assign(item, { text: item.description });
    });
    dispatch(
      setCities({
        newData: e?.geoNames,
        sliceState: getState()?.commonData?.data,
      })
    );
  });
};

export const GetGeoNames = () => (dispatch: any, getState: any) => {
  CommonServices.GetAllCars((e) => {
    e.geoNames?.forEach((item: any) => {
      Object.assign(item, { text: item.description });
    });
    dispatch(
      setGeoNames({
        newData: e?.geoNames,
        sliceState: getState()?.commonData?.data,
      })
    );
  });
};

export const GetProfileInfo = () => (dispatch: any, getState: any) => {
  CommonServices.GetProfileInfo((e) => {
    dispatch(
      setProfileInfo({
        newData: e?.account,
        sliceState: getState()?.commonData?.data,
      })
    );
  });
};
export const ChangeShowNavigation =
  (value: boolean) => (dispatch: any, getState: any) => {
    dispatch(
      setShowNavigation({
        newData: value,
        sliceState: getState()?.commonData?.data,
      })
    );
  };
